var binary = require('./lib/binary');

module.exports = binary;
